import React from 'react';

const StepComponent = ({ steps, activeStep, completedSteps = [], onStepClick }) => {
  const numericActive = Number(activeStep);
  const numericCompleted = (completedSteps || []).map(s => Number(s));
  
  return (
    <div className="flex-1">
      {steps.map((step) => {
        const isCompleted = numericCompleted.includes(step.id);
        const isActive = numericActive === step.id && numericActive > 0; // Only active if step > 0

        // Circle classes: filled primary color for active/completed, outlined for future
        const circleClasses = isCompleted || isActive
          ? 'bg-[#FF8E1C] text-white border-2 border-[#FF8E1C]'
          : 'bg-transparent text-[#FF8E1C] border-2 border-[#FF8E1C]';

        return (
          <div
            key={step.id}
            onClick={() => onStepClick(step.id)}
            className="flex items-center px-6 py-4 cursor-pointer text-white mb-2"
          >
            <div
              className={`w-10 h-[40px] border-2 border-[#FF8E1C] rounded-full font-lato not-italic font-medium text-[16px] flex items-center justify-center text-sm font-bold mr-4 transition-all duration-200 ${circleClasses}`}
              style={{ minWidth: 40 }}
            >
              {/* Show number when the step is active, otherwise show check for completed steps */}
              {isActive ? step.number : (isCompleted ? '✓' : step.number)}
            </div>
            <span className="font-lato not-italic font-bold text-[16px] leading-[150%] text-white">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
};

const Sidebar = ({ activeStep, completedSteps = [], onStepClick, totalSteps = 5 }) => {
  // Generate steps dynamically based on totalSteps
  const steps = Array.from({ length: totalSteps }, (_, index) => ({
    id: index + 1,
    number: String(index + 1).padStart(2, '0'),
    label: `Step ${index + 1}`
  }));

  return (
    <div className="w-64 bg-black text-white flex flex-col min-h-screen h-full rounded-[0px_12px_0px_0px]">
      {/* Logo Section */}
      <div className="p-6 ">
        <div className="flex items-center justify-center">
         <img src="./../assets/images/Logo-Incredible-Leaders.png" width={187} alt="Incredible Leaders" />
        </div>
      </div>

      <StepComponent
        steps={steps}
        activeStep={activeStep}
        completedSteps={completedSteps}
        onStepClick={onStepClick}
      />
    </div>
  );
};

export default Sidebar;